class subCollection extends HTMLElement {
    constructor() {
      super();

      const collectionId = document.querySelector(".collection-content").getAttribute('data-section-id');

      this.sections = {
        main: {
            sectionId: collectionId,
            nodeId: "CollectionAjaxContent"
        }
      };

      this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);
      this.subCollectionItems = this.querySelectorAll("[js-sub-collection-item]");

      this.subCollectionItems.forEach( item => {
        item.addEventListener('click', evt => {
            evt.preventDefault();
            const collectionHandle = evt.currentTarget.dataset.collectionHandle;
            this.initAjaxCollection(collectionHandle, this);
        })
      });

      document.addEventListener("update-scroll:init", this.updateScroll.bind(this));
    };

    initAjaxCollection(handle, targetEl) {
        this.changeActiveState(targetEl);
        this.updateHistoryState(handle);
        this.renderAjaxCollection(handle);
    };

    changeActiveState(targetEl) {
        this.subCollectionItems.forEach( item => item.classList.remove("active"));
        targetEl.classList.add('active');
    };

    updateHistoryState(handle) {
        let newurl = `${location.origin}/collections/${handle}`;
        if(location.pathname.includes('en-')) {
            newurl = `${location.origin}/${location.pathname.split('/')[1]}/collections/${handle}`;
        }
      
        window.history.replaceState({path: newurl}, '', newurl);
    };

    updateScroll() {
        const scrollToElement = document.querySelector('[data-scroll-to]');
        const rect = scrollToElement.getBoundingClientRect();
        const scrollTo = rect.top + window.scrollY;

        window.scrollTo({top: scrollTo - 50, behavior: 'smooth'});
    };

    renderAjaxCollection(handle) {
        let url = `${location.origin}/collections/${handle}?section_id=${this.sections.main.sectionId}`;
        if(location.pathname.includes('/en-')) {
            url = `${location.origin}/${location.pathname.split('/')[1]}/collections/${handle}?section_id=${this.sections.main.sectionId}`;
        }

        this.ajaxCollectionEl.classList.add("preloading");

        fetch(url).then(response => {
            return response.text();
        }).then(html => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            this.ajaxCollectionEl.innerHTML = doc.querySelector(`#${this.sections.main.nodeId}`).innerHTML;
            
            document.dispatchEvent(new CustomEvent("collection-grid-item:init"));
            document.dispatchEvent(new CustomEvent("cardHover:init"));
            document.dispatchEvent(new CustomEvent("swatch-color:init"));
            document.dispatchEvent(new CustomEvent("infiniteScroll:init"));
            this.updateScroll();
        });
    };
}
  
customElements.define('sub-collection', subCollection);